import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentUserProductionRewardValueObject} from "../../../../data/value-object/content/ContentUserProductionRewardValueObject";
import {ContentUserProductionRewardSearchOption} from "../../../../data/search-option/content/ContentUserProductionRewardSearchOption";
import {SearchIndex} from "../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../ListPageWrapper";
import {ContentUserProductionRewardIO} from "../../../../io/ContentIO";
import {ContentUserProductionRewardDescription} from "../../../../data/description/content/ContentUserProductionRewardDescription";
import {ContentUserProductionRewardDescriptor} from "../../../../data/descriptor/content/ContentUserProductionRewardDescriptor";
import ListOption from "../../../ListOption";
import {
    ContentUserProductionRewardSearchOptionDescription
} from "../../../../data/description/content/ContentUserProductionRewardSearchOptionDescription";
import {
    applyContentUserProductionRewardSearchOption,
    ContentUserProductionRewardSearchOptionField
} from "../../../search-option-field/content/ContentUserProductionRewardSearchOptionField";
import ListOrder from "../../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentUserProductionRewardValueObject[]>([])
    const option = useStatePair<ContentUserProductionRewardSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentUserProductionRewardIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentUserProductionRewardDescription}
                descriptor={ContentUserProductionRewardDescriptor}
                showPost
                onPostClick={() => document.location = '/contents/userProduction/durations/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/userProduction/durations/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentUserProductionRewardSearchOptionDescription}
                fields={ContentUserProductionRewardSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentUserProductionRewardSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentUserProductionRewardDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}